/**
 * Copyright 2017 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * */

import { LOGOUT_USER } from "openstack-uicore-foundation/lib/security/actions";
import {
  RECEIVE_SHOW_ACCESS,
  RECEIVE_SHOW_METADATA,
  REQUEST_SHOW_ACCESS,
  RECEIVE_SHOW_LOCATIONS
} from "../actions/show-actions";

const DEFAULT_STATE = {
  showAccess: null,
  showMetadata: null
};

// eslint-disable-next-line default-param-last
const showAccessReducer = (state = DEFAULT_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT_USER:
      return DEFAULT_STATE;
    case REQUEST_SHOW_ACCESS: {
      return DEFAULT_STATE;
    }
    case RECEIVE_SHOW_ACCESS: {
      const showAccess = payload.response;

      return { ...state, showAccess };
    }
    case RECEIVE_SHOW_METADATA: {
      const showMetadata = payload.response;

      return { ...state, showMetadata };
    }
    case RECEIVE_SHOW_LOCATIONS: {
      const mainLocations = (payload.response?.locations ?? []).filter(
        (l) => l.is_main
      );
      return {
        ...state,
        showMetadata: {
          ...state.showMetadata,
          main_locations: mainLocations
        },
        showAccess: state.showAccess
          ? {
              ...state.showAccess,
              summit: {
                ...state.showAccess.summit,
                main_locations: mainLocations
              }
            }
          : null
      };
    }
    default:
      return state;
  }
};

export default showAccessReducer;
